import { createRouter, createWebHashHistory } from "vue-router";
import { useAuthStore } from "@/modules/auth/stores/auth";
import { authRoutes } from "@/modules/auth/routes";
import { posRoutes } from "@/modules/pos/routes";
import { kitchenRoutes } from "@/modules/kitchen/routes";
import { notificationRoutes } from "@/modules/notifications/routes";
import { reportRoutes } from "@/modules/reports/routes";
import { settingsRoutes } from "@/modules/settings/routes";

const routes = [
    // Redirect root to login
    {
        path: "/",
        redirect: "/auth/login",
    },
    {
        path: "/select",
        name: "Select",
        component: () => import("../SelectVew.vue"),
    },
    ...authRoutes,
    ...posRoutes,
    ...kitchenRoutes,
    ...notificationRoutes,
    ...reportRoutes,
    ...settingsRoutes,
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to, _from, next) => {
    const authStore = useAuthStore();

    // Check if route requires auth
    if (to.meta.requiresAuth) {
        if (!authStore.isLoggedIn) {
            next({ name: "Login" });
            return;
        }
    }

    // If logged in and trying to access login, redirect
    if (to.name === "Login" && authStore.isLoggedIn) {
        const areaId = authStore.defaultAreaId;
        if (areaId) {
            next({ name: "Tables", params: { areaId } });
        } else {
            next({ name: "Areas" });
        }
        return;
    }

    next();
});

export default router;
